import { supabase } from '../lib/supabase';

type ErrorLoggingContext = {
  userId: string | null;
  companyId: string | null;
};

type SupabaseLikeError = {
  message?: string;
  code?: string;
  hint?: string;
};

const errorLoggingContext: ErrorLoggingContext = {
  userId: null,
  companyId: null,
};

export const setErrorLoggingContext = (context: Partial<ErrorLoggingContext>) => {
  if ('userId' in context) {
    errorLoggingContext.userId = context.userId ?? null;
  }
  if ('companyId' in context) {
    errorLoggingContext.companyId = context.companyId ?? null;
  }
};

export const getCurrentUserId = (): string | null => errorLoggingContext.userId;

export const getCurrentCompanyId = (): string | null => errorLoggingContext.companyId;

export const logSupabaseQueryError = (error: unknown) => {
  if (!error || typeof error !== 'object' || !('message' in error)) {
    return;
  }

  const supabaseError = error as SupabaseLikeError;
  void supabase.from('error_logs').insert({
    type: 'frontend',
    message: String(supabaseError.message || 'Supabase query error'),
    stack: null,
    user_id: getCurrentUserId() ?? null,
    company_id: getCurrentCompanyId() ?? null,
    context: {
      code: supabaseError.code,
      hint: supabaseError.hint,
      page: typeof window !== 'undefined' ? window.location.pathname : null,
    },
  });
};
